export default "__VITE_ASSET__Bgbx5xzX__"